import React from 'react'
import { connect } from 'react-redux'
import ErrorPage from '../../components/error_page'
import IntlMessages from '../../util/IntlMessages'

function NotFound(props) {

    return (
        <React.Fragment>
            <ErrorPage
                title={<IntlMessages id="404" />}
                message={<IntlMessages id="pageYouWereLookingForCouldNotBeFound" />}
            />
        </React.Fragment >
    )
}

export default connect()(NotFound)
